import React from "react";

export const ButtonTemplate = ({ children }) => {

    return(
        <div className="tile a2 am20-bm30-cm50 jc">
            { 
            children.length && 
            <>
                {children[0] ? children[0] : <></>}
                {children[1] ? children[1] : <></> }    
            </>
            }
            {
                children.length === undefined &&
                <>
                {children}
                </>
            }
        </div>
    )
}